<template>
  <nav>
    <div class="mx-auto px-4 sm:px-6 lg:px-8 z-40">
      <div class="flex justify-between h-12">
        <div class="flex">
          <!-- logo start -->
          <div @click="toggleSidebar()" class="flex-shrink-0 flex items-center">
            <img
              class="block lg:hidden px-1 h-6 w-auto"
              src="../../assets/nav_logo.svg"
              alt="logo mts"
            />
            <img
              class="hidden lg:block px-1 h-6 w-auto"
              src="../../assets/nav_logo.svg"
              alt="logo mts"
            />
          </div>
          <!-- logo end -->
          <!-- links start -->
          <div v-if="auth === 'ok'"
            class="hidden lg:ml-32 lg:space-x-10 md:flex md:space-x-4 md:ml-16"
          >
            <template v-for="module in currentNav.children">
              <navbar-link
                v-bind:key="module.title"
                :to="module.path"
                v-bind:title="$t(`message.${module.title}`)"
              />
            </template>

            <select @change="openDashboard($event.target.value)" class="mt-2 mb-2 block pl-3 pr-10 text-xs border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500  rounded-md">
              <option value="">Abrir Dashboard</option>
              <option v-for="d in dashboards" v-bind:key="d.key" v-bind:value="d.link"> {{d.name}} </option>
            </select>

          </div>
          <!-- links end -->
        </div>
        <!-- user info start -->
        <div class="hidden md:ml-6 md:flex md:items-center">
          <p class="pr-1 text-gray-600">{{$store.getters.auth.username}}</p>
          <div class="relative inline-block text-left" v-if="auth === 'ok'">
            <div>
              <button @click="isOpenConfig = !isOpenConfig" class="flex z-50 items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600" aria-label="Options" aria-haspopup="true" aria-expanded="true">
                <div class="text-xl">
                  <i class="fas fa-caret-down"></i>
                </div>
              </button>
            </div>
            <button v-if="isOpenConfig" @click="isOpenConfig = false" class="fixed inset-0 h-full w-full bg-black opacity-50 z-40"></button>
            <div v-if="isOpenConfig" @click="isOpenConfig = false" class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-50 transition transform"
              :class="`ease-${isOpenConfig ? 'out' : 'in'} duration-${isOpenConfig ? '100' : '75'} opacity-${isOpenConfig ? '100' : '0'} scale-${isOpenConfig ? '100' : '95'}`">
              <div class="rounded-md bg-white shadow-xs" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                <template v-if="navOptions.length > 0">
                  <div class="py-1" v-for="m in navOptions" v-bind:key="`${m.title}-${m.to}`">
                    <router-link :to="m.to" class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">
                      {{$t(`message.${m.title}`)}}
                    </router-link>
                  </div>
                </template>
                <div class="py-1">
                  <button @click.stop="logout" class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                    <div class="flex justify-between">
                      <label class="text-base">{{$t('message.cerrarsesion')}}</label>
                      <div class="text-base">
                        <i class="self-center fas fa-sign-out-alt"></i>
                      </div>
                    </div>
                  </button>
                </div>
                <div class="border-t border-gray-100"></div>
                <div class="py-1 text-center">
                  <p class="mr-2 text-gray-500 text-sm">v3.{{ version }}</p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- user button end -->
        <!-- Mobile menu buttons start -->
        <div :class="`-mr-2 flex items-center ${auth==='ok'?'':'hidden'} md:hidden`">
          <button
            @click="isOpen = !isOpen"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
          >
            <!-- Menu open: "hidden", Menu closed: "block" -->
            <svg
              :class="{ hidden: isOpen, block: !isOpen }"
              class="block h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <!-- Menu open: "block", Menu closed: "hidden" -->
            <svg
              :class="{ hidden: !isOpen, block: isOpen }"
              class="block h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <!-- Mobile menu buttons end -->
      </div>
    </div>
    <!--
      Mobile menu, toggle classes based on menu state.
      Open: "block", closed: "hidden"
    -->
    <!-- mobile menu links start -->
      <div :class="auth==='ok'?'':'hidden'">
        <div :class="isOpen ? 'block' : 'hidden'" class="md:hidden">
          <div class="pt-1 pb-2 space-y-1">
            <template v-for="module in currentNav.children">
              <navbar-link-mobile
                v-bind:key="module.title"
                :to="module.path"
                :title="$t(`message.${module.title}`)"
              />
            </template>
            <div class="mr-4 ml-4">
              <select @change="openDashboard($event.target.value)" class="w-full mt-2 mb-2 block pl-3 pr-10 text-xs border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500  rounded-md">
                <option value="">Abrir Dashboard</option>
                <option v-for="d in dashboards" v-bind:key="d.key" v-bind:value="d.link"> {{d.name}} </option>
              </select>
              <div class="border-t border-gray-200"></div>
              <div class="pt-1 pb-1">
                <div class="mt-1 mb-1">
                  <label class="text-base text-gray-700">
                    {{$t('message.nombresesion')}}:
                  </label>
                  <label class="text-base leading-5 font-medium text-gray-900 truncate">
                    {{$store.getters.auth.login}}
                  </label>
                </div>
                <button @click.stop="logout" class="mt-2 mb-1 block w-full text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                  <div class="flex justify-between">
                    <label class="text-base font-bold">{{$t('message.cerrarsesion')}}</label>
                    <div class="text-base">
                      <i class="self-center fas fa-sign-out-alt"></i>
                    </div>
                  </div>
                </button>
              </div>
              <div class="border-t border-gray-200"></div>
              <div class="text-center">
                <p class="mr-2 text-gray-500 text-sm">v3.{{ version }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile menu links end -->
  </nav>
</template>

<script>
import NavbarLink from '@/components/Navbar/NavbarLink';
import NavbarLinkMobile from '@/components/Navbar/NavbarLinkMobile';
export default {
  components: { NavbarLink, NavbarLinkMobile },
  mounted() {
    if (this.auth === 'ok') {
      this.fetchDash()
      this.getMenuConfig()
    }
  },
  data() {
    return {
      dashboards: [{'link': '', 'name': 'Abrir Dashboard', 'key': '0'}],
      isOpen: false,
      isOpenConfig: false,
      navOptions: []
    };
  },
  computed: {
    currentNav() {
      return this.$store.getters.currentNav;
    },
    auth() {
      return this.$store.getters.auth.result;
    },
    version() {
      return process.env.VUE_APP_GIT_HASH;
    }
  },
  watch: {
    auth(newVal) {
      if  (newVal === 'ok') {
        this.fetchDash()
        this.getMenuConfig()
      }
    }
  },
  methods: {
    logout() {
      this.isOpenConfig = false;
      this.isOpen = false;
      this.$store.dispatch('logout');
      this.$store.dispatch('updateCurrentNav', {});
    },
    toggleStatus() {
      this.isOpen = !this.isOpen;
    },
    toggleSidebar() {
      this.$parent.toggleSidebar();
    },
    openDashboard(url) {
      if (url !== '') {
        window.open(url, '_blank');
      }
    },
    async fetchDash() {
      const response = await this.$http.get(`/dashboards`);
      this.dashboards = response.data;
      console.log(this.dashboards);
    },
    openConfig(){
      this.isOpenConfig = !this.isOpenConfig;
    },
    async getMenuConfig(){
      const { data } = await this.$http.get(`/navoptions`);
      this.navOptions = data;
    }
  }
};
</script>
